<template>
  <li class="timeline-item ">
    <div class="timeline-badge ">
      <!--      <icon  v-bind:name="{'registered': statusRegistered,'tick': statusSuccess, 'cross': statusCancellation,'progress': !statusSuccess && !statusCancellation && !statusRegistered }" class="h-6 mb-2 inline fill-white"></icon>-->
      <icon  v-bind:name="iconName" class="h-6 mb-2 inline fill-white"></icon>
    </div>
    <div class="timeline-panel ">



      <div class="timeline-heading">
        <h4 class="timeline-title">
          <span class="mx-0.5 px-2 py-1 rounded-md text-white" :class="itemStatusColor">
          {{ item.status }}
        </span>
        </h4>
        <div class="timeline-panel-controls">
          <div class="timestamp">
            <small >{{ item.hr_created_at }}</small>
            <br>
            <small >{{ item.user }}</small>
          </div>
        </div>
      </div>
      <div class="timeline-body mt-5">{{ item.description }}</div>
      <div v-if="item.comment" class="timeline-body">Koment: {{item.comment}}</div>
      <div v-if="item.document_path" class="timeline-body">Dëshmi: <a class="px-4 py-1 text-white text-xs font-medium bg-gray-500 hover:bg-gray-700 rounded-sm"  :href="route('files.download', {path: item.document_path})" download>Shkarko</a></div>

    </div>
  </li>
</template>

<script>
import FileOutput from '@/Shared/FileOutput'
import Icon from '@/Shared/Icon'

export default {
  name: 'OrderChangeStatusTimelineItem',
  components: {
    FileOutput,
    Icon
  },
  props: {
    item: Object,
    statusColor: String
  },
  data() {
    return {
      statusRegistered: this.item.status_id === 1,
      statusSuccess: this.item.status_id === 5,
      statusCancellation: this.item.status_id === 7,
    }
  },
  computed: {
    iconName(){
      let iconName = 'progress'
      if(this.item.status_id === 1)
        iconName = 'registered'

      if(this.item.status_id === 3)
        iconName = 'warehouse'

      if(this.item.status_id === 4)
        iconName = 'shipping'

      if(this.item.status_id === 5)
        iconName = 'tick'

      if(this.item.status_id === 6)
        iconName = 'cross'



      return iconName
    },
    itemStatusColor(){
      let statusColor = 'bg-indigo-500'
      if(this.item.status_id === 1)
        statusColor = 'bg-yellow-500'

      if(this.item.status_id === 3)
        statusColor = 'bg-orange-500'

      if(this.item.status_id === 4)
        statusColor = 'bg-indigo-900'

      if(this.item.status_id === 5)
        statusColor = 'bg-green-500'

      if(this.item.status_id === 6)
        statusColor = 'bg-red-500'


      return statusColor
    }


  }
}
</script>
